import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  defaultTitle: {
    id: 'contactCard.default.title',
    defaultMessage: 'For more information, contact:',
  },
});

export type ContactCardData = {
  title?: string;
  text?: string;
  ctaLabel?: string;
  email?: string;
};

const ContactCardView = ({ data }: { data: ContactCardData }) => {
  const intl = useIntl();

  const renderCta = data.ctaLabel && data.email;

  return (
    <div className="block-contact-card">
      <div className="contact-card__content">
        <h2 className="contact-card__title">
          {data.title || intl.formatMessage(messages.defaultTitle)}
        </h2>

        {data.text && <p className="contact-card__text">{data.text}</p>}

        {renderCta && (
          <a
            className="btn btn--primary contact-card__cta"
            href={`mailto:${data.email}`}
          >
            {data.ctaLabel}
          </a>
        )}
      </div>
    </div>
  );
};

export default ContactCardView;
